import {
  Box,
  Button,
  Container,
  Group,
  Text,
} from "@mantine/core";
import { useLocation } from "react-router-dom";

export default function Navbar() {
  const { pathname, search } = useLocation();

  const params = new URLSearchParams(search);
  const hasShopKey = params.has("shopKey");

  // Hide right-side buttons for QR flow OR booking page
  const hideRightButtons = hasShopKey || pathname === "/booking";

  return (
    <Box
      py={16}
      px={1}
      style={{
        backgroundColor: "#111",
        borderBottom: "1px solid #2a2a2a",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      <Container size="lg">
        <Group justify="space-between" wrap="nowrap">
          <Text
            component="a"
            href="/"
            fw={900}
            size="xl"
            c="white"
            style={{
              whiteSpace: "nowrap",
              textDecoration: "none",
            }}
          >
            RentalFlow
          </Text>

          {!hideRightButtons && (
            <Group gap={10} wrap="nowrap">
              <Button
                component="a"
                href="/pricing"
                color="gray"
                radius={8}
                size="compact-sm"
                style={{
                  backgroundColor: "#f24c1a",
                }}
              >
                Pricing
              </Button>

              <Button
                component="a"
                href="https://app.rentalflow.in"
                radius={8}
                size="compact-sm"
                style={{
                  backgroundColor: "#f24c1a",
                }}
              >
                App
              </Button>

              <Button
                component="a"
                href="/product"
                radius={8}
                size="compact-sm"
                style={{
                  backgroundColor: "#f24c1a",
                }}
              >
                Tour
              </Button>
            </Group>
          )}
        </Group>
      </Container>
    </Box>
  );
}